import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import md5 from 'js-md5'
import urls from '../common/js/urls.js'

export function api_course_detail(context, course_id) {
  var domain = window.location.host;
  var application_id = 1;
  if (domain == 'runyu.winlesson.com' || domain == 'www.runyubisheng.com') {
    application_id = 300;
  }
  var url = urls.course_detail + "?course_id=" + course_id + "&application_id=" + application_id;
  var user_id = localStorage.getItem("user_id")
  if (user_id && user_id != '') {
    url += '&user_id=' + user_id
  }
  var promise = new Promise(function (resolve, reject) {
    axios.get(url).then((response) => {
      var data = response.data;
      resolve(data);
    }).catch((response) => {
      reject(response);
    })
  });
  return promise;
}

export function api_course_videos(context, course_id, user_id) {
  var domain = window.location.host;
  var application_id = 1;
  if (domain == 'runyu.winlesson.com' || domain == 'www.runyubisheng.com') {
    application_id = 300;
  }
  var promise = new Promise(function (resolve, reject) {
    axios.get(urls.course_videos + "?course_id=" + course_id + "&user_id=" + user_id + "&ver=6.7.0&&application_id=" + application_id).then((response) => {
      var data = response.data;
      resolve(data);
    }).catch((response) => {
      reject(response);
    })
  });
  return promise;
}

export function api_video_live_status(context, current_video) {
  var promise = new Promise(function (resolve, reject) {
    var domain = window.location.host;
    var application_id = 1;
    if (domain == 'runyu.winlesson.com' || domain == 'www.runyubisheng.com') {
      application_id = 300;
    }
    axios.post(urls.live_status + '?userid=' + context.current_user.user_id + '&channelId=' + current_video.channelId + "&application_id=" + application_id).then((response) => {
      var data = response.data;
      resolve(data);
    }).catch((response) => {
      reject(response);
    })
  });
  return promise;
}

export function api_video_live_chat_list(context, course_id) {
  var domain = window.location.host;
  var application_id = 1;
  if (domain == 'runyu.winlesson.com' || domain == 'www.runyubisheng.com') {
    application_id = 300;
  }
  var url = urls.getChatList + '?courseId=' + course_id + "&application_id=" + application_id;
  var promise = new Promise(function (resolve, reject) {
    axios.post(url).then((response) => {
      var data = response.data;
      resolve(data);
    }).catch((response) => {
      reject(response);
    })
  });
  return promise;
}

export function api_video_report_record(context, recordTime) {
  var domain = window.location.host;
  var application_id = 1;
  if (domain == 'runyu.winlesson.com' || domain == 'www.runyubisheng.com') {
    application_id = 300;
  }
  var url = urls.add_video_record + '?userid=' + context.current_user.user_id + '&courseId=' + context.course_info.course_id + '&videoId=' + context.video_now.videoId + '&playedTime=' + recordTime + "&application_id=" + application_id;
  var promise = new Promise(function (resolve, reject) {
    axios.post(url).then((response) => {
      var data = response.data;
      resolve(data);
    }).catch((response) => {
      reject(response);
    })
  });
  return promise;
}

export function api_video_send_chat(context) {
  var domain = window.location.host;
  var application_id = 1;
  if (domain == 'runyu.winlesson.com' || domain == 'www.runyubisheng.com') {
    application_id = 300;
  }
  var url = urls.postChat + "?courseId=" + context.router_course_id + '&userid=' + context.current_user.user_id + '&content=' + context.chatform.msg + "&application_id=" + application_id;
  var promise = new Promise(function (resolve, reject) {
    axios.post(url).then((response) => {
      var data = response.data;
      resolve(data);
    }).catch((response) => {
      reject(response);
    })
  });
  return promise;
}



// WEBPACK FOOTER //
// ./src/networks/CourseHandler.js